import { Controller } from "@hotwired/stimulus"
import React from "react"
import { createRoot } from "react-dom/client"
import { TreeSelect } from "antd"

export default class extends Controller {
  static targets = ["input", "container"]
  static values = {
    data: Array,
    placeholder: String
  }

  connect() {
    this.root = createRoot(this.containerTarget)
    this.render()
  }

  disconnect() {
    this.root.unmount()
  }

  render() {
    const rawValue = this.inputTarget.value;
    const parsedValue = (rawValue && !isNaN(rawValue)) ? Number(rawValue) : rawValue;
    this.root.render(
      React.createElement(TreeSelect, {
        treeData: this.dataValue,
        placeholder: "Выберите категорию...",
        defaultValue: parsedValue || undefined,
        treeLine: true,
        allowClear: true,
        showSearch: true,
        treeNodeFilterProp: "title",
        notFoundContent: "Ничего не найдено",
        onChange: (value) => {
          this.inputTarget.value = value || ""
          this.inputTarget.dispatchEvent(new Event("change"))
        }
      })
    )
  }
}